// extracted by mini-css-extract-plugin
export default {"container":"notes_container__UPvmh"};